import api from './api';

const pricingModelMasterService = {
  getAllPricingModelMasters: async (params) => {
    try {
      const response = await api.get('/pricing-model-masters', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing model masters:', error);
      throw error;
    }
  },
  getPricingModelMasterById: async (id) => {
    try {
      const response = await api.get(`/pricing-model-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching pricing model master with ID ${id}:`, error);
      throw error;
    }
  },
  createPricingModelMaster: async (pricingModelData) => {
    try {
      const response = await api.post('/pricing-model-masters', pricingModelData);
      return response.data;
    } catch (error) {
      console.error('Error creating pricing model master:', error);
      throw error;
    }
  },
  updatePricingModelMaster: async (id, pricingModelData) => {
    try {
      const response = await api.put(`/pricing-model-masters/${id}`, pricingModelData);
      return response.data;
    } catch (error) {
      console.error(`Error updating pricing model master with ID ${id}:`, error);
      throw error;
    }
  },
  deletePricingModelMaster: async (id) => {
    try {
      const response = await api.delete(`/pricing-model-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting pricing model master with ID ${id}:`, error);
      throw error;
    }
  },
  getPricingModelMasterStats: async () => {
    try {
      const response = await api.get('/pricing-model-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing model master stats:', error);
      throw error;
    }
  }
};

export default pricingModelMasterService;
